import { render } from "./ClientProveedoresListado.vue?vue&type=template&id=a39da97a&scoped=true"
import script from "./ClientProveedoresListado.vue?vue&type=script&lang=js"
export * from "./ClientProveedoresListado.vue?vue&type=script&lang=js"

import "./ClientProveedoresListado.vue?vue&type=style&index=0&id=a39da97a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a39da97a"]])

export default __exports__